import { Fragment, useEffect, useState, useCallback, useRef } from "react";
import { useSelector, useDispatch, connect } from "react-redux";
import "./package_details_component.scss";
import LoaderPopUp from "../../../../../../components/loader/loader";
import HeaderComponent from "../../../../structure_components/desktop_screens/header_component/header_component";
import "react-toastify/dist/ReactToastify.css";
import uiActions from "../../../../../../redux/ui/action";
import { setStoreCurrentPackageDetails } from "../../../../../../redux/packages_store/PackageSlice";
import FrequentlyBought from "../modal/FrequentlyBought/FrequentlyBought";
import { StoreBanner } from "./package_overview/StoreComponents/StoreBanner/StoreBanner";
import { StoreTabs } from "./package_overview/StoreComponents/StoreTabs/StoreTabs";
import { StoreDescription } from "./package_overview/StoreComponents/StoreDescription/StoreDescription";
import { StoreOrientationVideo } from "./package_overview/StoreComponents/StoreOrientationVideo/StoreOrientationVideo";
import { StoreComboCourses } from "./package_overview/StoreComponents/StoreComboCourses/StoreComboCourses";
import { StorePerformanceBanner } from "./package_overview/StoreComponents/StorePerformanceBanner/StorePerformanceBanner";
import { StoreFacultyDetails } from "./package_overview/StoreComponents/StoreFacultyDetails/StoreFacultyDetails";
import { StoreOtherDetails } from "./package_overview/StoreComponents/StoreOtherDetails/StoreOtherDetails";
import StoreCourseStory from "./package_overview/StoreComponents/StoreCourseStory/StoreCourseStory";
import StoreCourseDetails from "./package_overview/StoreComponents/StoreCourseDetails/StoreCourseDetails";
import StoreCourseMode from "./package_overview/StoreComponents/StoreCourseMode/StoreCourseMode";
import StorePackageHeader from "./package_overview/StoreComponents/StorePackageHeader/StorePackageHeader";
import { StoreSubjects } from "./package_overview/StoreComponents/StoreSubjects/StoreSubjects";
import { useLocation, useParams, useRouteMatch } from "react-router-dom";
import { shouldHideStoreCheckoutHeader } from "../../../../../../custom_utilities/dashboardBannerNavigation";
import { Render } from "../../../../../homepage/Render";
import { fetchPackageData } from "./package_overview/StoreComponents/StoreUtils/StoreApiUtils";
import axioInstance from "../../../../../../custom_utilities/AxiosInstance/axiosInstance";
import { url_store_package_deltaupgrade } from "../../../../../../custom_utilities/api_services";
import StoreVariantSelection from "./package_overview/StoreComponents/StoreVariantSelection/StoreVariantSelection";
import StoreFrequentlyBought from "./package_overview/StoreComponents/StoreFrequentlyBought/StoreFrequentlyBought";
import StorePaymentPage from "./package_overview/StoreComponents/StorePaymentPage/StorePaymentPage";
import StorePlanCheckout, {
  bundlePlanLabel,
  singleSectionLabel,
} from "./package_overview/StoreComponents/StorePlanCheckout/StorePlanCheckout";
import StoreOverview from "./package_overview/StoreComponents/StoreOverview/StoreOverview";
import { StoreRecentBought } from "./package_overview/StoreComponents/StoreRecentBought/StoreRecentBought";
import { trackWebEngageProgramViewed } from "../../../../../../custom_utilities/webengage/webengageService";

const PackageDetailsComponent = ({ setStoreCurrentPackageDetails }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { id: selectedPackageId } = useParams();
  const isCheckout = Boolean(
    useRouteMatch({ path: "/package/:id/checkout", exact: true })
  );
  const loader = useSelector((state) => state.ui.loader);
  const variantChangeRef = useRef(false);
  const programViewedRef = useRef(null);
  const [packageData, setPackageData] = useState(null);
  const [initialPackageVariants, setInitialPackageVariants] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedRelatedPackages, setSelectedRelatedPackages] = useState([]);
  const [selectedFrequentPackages, setSelectedFrequentPackages] = useState([]);
  const [addonDiscount, setAddonDiscount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [upgradeQuote, setUpgradeQuote] = useState(null);
  const [upgradeCheckDone, setUpgradeCheckDone] = useState(false);
  const [couponCode, setCouponCode] = useState(
    typeof location.state === "string" ? location.state : ""
  );
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [showFrequentlyBoughtDetails, setShowFrequentlyBoughtDetails] =
    useState(false);
  const [frequentlyBoughtDetails, setFrequentlyBoughtDetails] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const initialTab =
    searchParams.get("tab") ||
    location?.state?.tab ||
    location?.state?.activeTab ||
    "details";
  const [active, setActive] = useState(initialTab);

  const startLoading = useCallback(
    () => dispatch(uiActions.startLoading()),
    [dispatch]
  );
  const finishLoading = useCallback(
    () => dispatch(uiActions.finishLoading()),
    [dispatch]
  );

  useEffect(() => {
    if (!selectedPackageId) return;

    finishLoading();
    variantChangeRef.current = false;
    programViewedRef.current = null;
    setPackageData(null);
    setInitialPackageVariants(null);
    setSelectedPackage(null);
    setSelectedRelatedPackages([]);
    setSelectedFrequentPackages([]);
    setCouponCode(typeof location.state === "string" ? location.state : location?.state?.couponCode || "");
    setCouponDiscount(0);
    setAddonDiscount(0);
    const searchParams = new URLSearchParams(location.search);
    const resolvedTab =
      searchParams.get("tab") ||
      location?.state?.tab ||
      location?.state?.activeTab ||
      "details";
    setActive(resolvedTab);

    fetchPackageData({
      packageId: selectedPackageId,
      isInitialLoad: true,
      setPackageData,
      setStoreCurrentPackageDetails,
      setFinalAmount,
      setInitialPackageVariants,
      setSelectedPackage,
      startLoading,
      finishLoading,
    });
  }, [
    selectedPackageId,
    setStoreCurrentPackageDetails,
    startLoading,
    finishLoading,
    location.state,
    location.search,
  ]);

  useEffect(() => {
    const product = selectedPackage || packageData;
    const productId = product?.package_id || selectedPackageId;
    if (!product || !productId) return;
    if (programViewedRef.current === String(productId)) return;

    programViewedRef.current = String(productId);
    const installment = packageData?.PackageInstallmentDetails || {};
    const priceDetails = packageData?.price_details || {};
    const mrp =
      product?.amount ||
      priceDetails?.course_price ||
      installment?.amount;
    const payable =
      finalAmount ||
      product?.discounted_price ||
      product?.amount ||
      installment?.discounted_price;
    const discount =
      product?.discount ||
      priceDetails?.discount ||
      installment?.discount ||
      (mrp != null && payable != null ? Number(mrp) - Number(payable) : 0);

    trackWebEngageProgramViewed(
      {
        ...installment,
        ...product,
        package_id: productId,
        package_name:
          product?.package_name ||
          product?.title ||
          product?.name ||
          installment?.package_name,
        description: product?.description || installment?.description,
        discount,
        amount: mrp,
        discounted_price: payable,
        price_details: priceDetails,
      },
      { offers: discount }
    );
  }, [packageData, selectedPackage, selectedPackageId, finalAmount]);

  useEffect(() => {
    let cancelled = false;
    setUpgradeQuote(null);
    setUpgradeCheckDone(false);
    if (!selectedPackageId) {
      setUpgradeCheckDone(true);
      return undefined;
    }

    axioInstance
      .get(`${url_store_package_deltaupgrade}?package_id=${selectedPackageId}`)
      .then((response) => {
        if (cancelled) return;
        const quote = response?.data?.data;
        if (quote?.show_upgrade === 1 && quote?.deltaupgrade_payload) {
          setUpgradeQuote(quote);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setUpgradeCheckDone(true);
      });

    return () => {
      cancelled = true;
    };
  }, [selectedPackageId]);

  const upgradePayAmount = (() => {
    const payload = upgradeQuote?.deltaupgrade_payload;
    const rounded = Number(payload?.delta_pay_rounded);
    if (Number.isFinite(rounded)) return rounded;
    const payAmount = Number(upgradeQuote?.upgrade_card?.pay_amount);
    return Number.isFinite(payAmount) ? payAmount : null;
  })();

  const upgradeCredit = (() => {
    const coursePrice = parseFloat(packageData?.price_details?.course_price || 0);
    const listedDiscount = parseFloat(packageData?.price_details?.discount || 0);
    const listedBase = Math.max(0, coursePrice - listedDiscount);
    if (upgradePayAmount == null || !Number.isFinite(upgradePayAmount) || upgradePayAmount >= listedBase) {
      return 0;
    }
    return listedBase - upgradePayAmount;
  })();

  const handleVariantSelection = useCallback((nextPackage) => {
    variantChangeRef.current = true;
    setSelectedPackage(nextPackage);
  }, []);

  useEffect(() => {
    if (!variantChangeRef.current) return;

    const nextPackageId = selectedPackage?.package_id;
    if (!nextPackageId) return;
    if (Number(nextPackageId) === Number(selectedPackageId)) {
      variantChangeRef.current = false;
      return;
    }

    variantChangeRef.current = false;
    setCouponCode("");
    setCouponDiscount(0);
    setAddonDiscount(0);

    fetchPackageData({
      packageId: nextPackageId,
      isInitialLoad: false,
      setPackageData,
      setStoreCurrentPackageDetails,
      setFinalAmount,
      setInitialPackageVariants,
      setSelectedPackage,
      startLoading,
      finishLoading,
    });
  }, [
    selectedPackage?.package_id,
    selectedPackageId,
    setStoreCurrentPackageDetails,
    startLoading,
    finishLoading,
  ]);

  // Price calculations
  useEffect(() => {
    if (
      packageData &&
      packageData.price_details &&
      packageData.price_details.course_price != null
    ) {
      const basePrice =
        parseFloat(packageData.price_details.course_price || 0) -
        parseFloat(packageData.price_details.discount || 0) -
        upgradeCredit;

      // Ensure couponDiscount doesn't exceed basePrice
      const validCouponDiscount = Math.min(
        parseFloat(couponDiscount || 0),
        basePrice
      );

      const relatedPackagesPrice = selectedRelatedPackages.reduce(
        (sum, pkg) => sum + parseFloat(pkg.amount || 0),
        0
      );

      const totalAddonDiscount = selectedRelatedPackages.reduce(
        (sum, pkg) => sum + parseFloat(pkg.discount || 0),
        0
      );

      const calculatedFinalAmount =
        basePrice -
        validCouponDiscount +
        relatedPackagesPrice -
        totalAddonDiscount;
      setAddonDiscount(totalAddonDiscount.toFixed(2));
      setFinalAmount(Math.max(0, calculatedFinalAmount).toFixed(2));
    } else {
      console.warn("Skipping finalAmount calculation: incomplete packageData", {
        packageData,
      });
    }
  }, [packageData, selectedRelatedPackages, couponDiscount, upgradeCredit]);

  const openFrequentBoughtDetails = (data) => {
    setFrequentlyBoughtDetails(data);
    setShowFrequentlyBoughtDetails(true);
  };
  const closeFrequentlyBoughtDetails = () =>
    setShowFrequentlyBoughtDetails(false);

  const hideAppHeader = shouldHideStoreCheckoutHeader(location);
  const planSection = singleSectionLabel(packageData) || bundlePlanLabel(packageData);

  const paymentPage = (
    <StorePaymentPage
      selectedFrequentPackages={selectedFrequentPackages}
      packageData={packageData}
      selectedPackage={selectedPackage}
      selectedPackageId={selectedPackageId}
      addonDiscount={addonDiscount}
      upgradeCredit={upgradeCredit}
      upgradePayload={upgradeQuote?.deltaupgrade_payload || null}
      upgradeCheckDone={upgradeCheckDone}
      finalAmount={finalAmount}
      setFinalAmount={setFinalAmount}
      couponCode={couponCode}
      couponDiscount={couponDiscount}
      setCouponDiscount={setCouponDiscount}
      setCouponCode={setCouponCode}
      setAddonDiscount={setAddonDiscount}
      startLoading={startLoading}
      finishLoading={finishLoading}
      selectedRelatedPackages={selectedRelatedPackages}
    />
  );

  if (isCheckout && !packageData) {
    return (
      <Render if={loader}>
        <LoaderPopUp />
      </Render>
    );
  }

  if (isCheckout && planSection) {
    return (
      <Fragment>
        <StoreOverview
          packageData={packageData}
          selectedPackage={selectedPackage}
          selectedPackageId={selectedPackageId}
          selectedFrequentPackages={selectedFrequentPackages}
          addonDiscount={addonDiscount}
          upgradeCredit={upgradeCredit}
          upgradePayload={upgradeQuote?.deltaupgrade_payload || null}
          upgradeCheckDone={upgradeCheckDone}
          finalAmount={finalAmount}
          setFinalAmount={setFinalAmount}
          couponCode={couponCode}
          setCouponCode={setCouponCode}
          couponDiscount={couponDiscount}
          setCouponDiscount={setCouponDiscount}
          setAddonDiscount={setAddonDiscount}
          startLoading={startLoading}
          finishLoading={finishLoading}
        />
        <Render if={loader}>
          <LoaderPopUp />
        </Render>
      </Fragment>
    );
  }

  if (isCheckout) {
    return (
      <Fragment>
        {!hideAppHeader ? <HeaderComponent /> : null}
        <StorePackageHeader packageData={packageData} />
        <div
          className={`store_page store-checkout${
            hideAppHeader ? " store_page--from-dashboard" : ""
          }`}
        >
          {paymentPage}
        </div>
        <Render if={loader}>
          <LoaderPopUp />
        </Render>
      </Fragment>
    );
  }

  return (
    <Fragment>
      {!hideAppHeader ? <HeaderComponent /> : null}
      <StorePackageHeader packageData={packageData} />
      <div
        className={`store_page${
          hideAppHeader ? " store_page--from-dashboard" : ""
        }`}
      >
        <StoreCourseMode packageData={packageData} />
        <div className="store_page__body">
        <div className="store_page__content">
          <StoreBanner packageData={packageData?.PackageInstallmentDetails} />
          <StoreTabs
            packageData={packageData}
            active={active}
            setActive={setActive}
          />
          <StoreRecentBought
            packageData={
              packageData?.PackageInstallmentDetails?.buyers_animation
            }
          />
          <Render if={active === "details"}>
            <StoreCourseDetails packageData={packageData} />
          </Render>
          <Render if={active === "desc"}>
            <>
              <StoreDescription
                packageData={packageData?.PackageInstallmentDetails}
              />
              <StoreOrientationVideo
                packageData={packageData?.orientation_video}
              />
              <StoreCourseStory packageData={packageData} />
              <StoreVariantSelection
                initialPackageVariants={initialPackageVariants}
                selectedPackage={selectedPackage}
                setSelectedPackage={handleVariantSelection}
                selectedPackageId={selectedPackageId}
              />
              <StoreFrequentlyBought
                packageData={packageData}
                selectedRelatedPackages={selectedRelatedPackages}
                setSelectedRelatedPackages={setSelectedRelatedPackages}
                selectedFrequentPackages={selectedFrequentPackages}
                setSelectedFrequentPackages={setSelectedFrequentPackages}
                openFrequentBoughtDetails={openFrequentBoughtDetails}
              />
              <StoreComboCourses
                packageData={packageData?.package_combos?.combo_options}
              />
              <StorePerformanceBanner />
              <StoreFacultyDetails packageData={packageData?.faculty_list} />
              <StoreOtherDetails packageData={packageData?.other_details} />
            </>
          </Render>
          <Render if={active === "subjects"}>
            <StoreSubjects
              packageData={packageData?.subject}
              courseId={
                packageData?.course_id ||
                packageData?.PackageInstallmentDetails?.course_id ||
                selectedPackage?.course_id
              }
            />
          </Render>
        </div>
        {planSection ? (
          <StorePlanCheckout
            packageData={packageData}
            sectionLabel={planSection}
            upgradeCredit={upgradeCredit}
          />
        ) : (
          paymentPage
        )}
        </div>
      </div>
      <Render if={showFrequentlyBoughtDetails}>
        <FrequentlyBought
          handleClose={closeFrequentlyBoughtDetails}
          frequentlyBoughtDetails={frequentlyBoughtDetails}
        />
      </Render>

      <Render if={loader}>
        <LoaderPopUp />
      </Render>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  orderId: state.paymentReducer.orderId,
});

const mapDispatchToProps = (dispatch) => ({
  setStoreCurrentPackageDetails: (payload) =>
    dispatch(setStoreCurrentPackageDetails(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PackageDetailsComponent);
